<template>
  <div class="wrapper daftarkan-masjid">
    <div class="donation-detail">
      <div
        class="main-content bg-white"
        style="padding: 15px; padding-bottom: 30px;"
      >
        <div class="wrapper-form">
          <form @submit.prevent="handleRegister">
            <!-- INFORMASI PENGURUS -->
            <h3>Data Diri</h3>
            <SizedBox :height="60" />

            <div class="form-group">
              <label for="kota"
                ><strong>Pilih Masjid / Yayasan</strong></label
              >
              <Select2
                v-model="masjidid"
                :options="dataMasjid"
                :settings="{
                  placeholder: 'Pilih Masjid / Yayasan',
                  escapeMarkup: escapeMarkup,
                  templateResult: templateResult,
                  templateSelection: templateSelection,
                }"
              />
              <div
                class="error"
                v-if="$v.masjidid.$dirty && !$v.masjidid.required"
              >
                Pilihan Masjid / Yayasan wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="fullname"
                ><strong>Nama Yatim / Dhuafa</strong></label
              >
              <input
                v-model="fullname"
                type="text"
                class="form-control"
                placeholder="Nama Yatim / Dhuafa"
                name="fullname"
              />
              <div
                class="error"
                v-if="$v.fullname.$dirty && !$v.fullname.required"
              >
                Nama Lengkap wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="kota"><strong>Status</strong></label>
              <Select2
                v-model="person_type"
                :options="dataPersonType"
                :settings="{ placeholder: 'Pilih Status' }"
              />
              <div
                class="error"
                v-if="
                  $v.person_type.$dirty && !$v.person_type.required
                "
              >
                Status wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="email"><strong>Email</strong></label>
              <input
                v-model="email"
                type="text"
                class="form-control"
                placeholder="Email Anda"
                name="email"
              />
              <div
                class="error"
                v-if="$v.email.$dirty && !$v.email.required"
              >
                Email wajib diisi.
              </div>
              <div
                class="error"
                v-if="$v.email.$dirty && !$v.email.email"
              >
                Format email anda salah.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="no_telp"
                ><strong>Nomor Telepon / HP</strong></label
              >
              <input
                v-model="no_telp"
                type="text"
                class="form-control"
                placeholder="Nomor Telepon / HP Anda"
                name="no_telp"
                v-number-only
              />
              <div
                class="error"
                v-if="$v.no_telp.$dirty && !$v.no_telp.required"
              >
                Nomor telepon wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="jeniskelamin"
                ><strong>Jenis Kelamin</strong></label
              >
              <Select2
                v-model="jeniskelamin"
                :options="dataJenisKelamin"
                :settings="{ placeholder: 'Pilih Jenis Kelamin' }"
              />
              <div
                class="error"
                v-if="
                  $v.jeniskelamin.$dirty && !$v.jeniskelamin.required
                "
              >
                Jenis Kelamin wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="kota"
                ><strong>Pendidikan Terakhir</strong></label
              >
              <Select2
                v-model="pendidikan_terakhir"
                :options="dataPendidikan"
                :settings="{ placeholder: 'Pilih Pendidikan' }"
              />
            </div>

            <SizedBox :height="15" />
            <div class="form-group">
              <label for="tanggallahir"
                ><strong>Tanggal Lahir</strong></label
              >
              <date-picker
                v-model="tanggallahir"
                type="datetime"
                class="form-control"
              ></date-picker>
              <div
                class="error"
                v-if="
                  $v.tanggallahir.$dirty && !$v.tanggallahir.required
                "
              >
                Tanggal Lahir wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="masjed_address">
                <strong>Tempat Lahir </strong>
              </label>
              <textarea
                name="tempat_lahir"
                v-model="tempat_lahir"
                class="form-control"
                placeholder="Tempat Lahir Anda"
                style="min-height: 150px"
              ></textarea>
            </div>

            <SizedBox :height="15" />

            <h3>Data Pendukung</h3>

            <SizedBox :height="60" />

            <div class="form-group">
              <label for="kk_url"
                ><strong>Foto Yatim / Dhuafa</strong></label
              >
              <div class="card">
                <div class="cekrek" v-if="!fotoyatimdhuafa_url">
                  <img src="/img/cekrek.png" />
                </div>
                <div id="preview" class="preview">
                  <img
                    v-if="fotoyatimdhuafa_url"
                    :src="fotoyatimdhuafa_url"
                  />
                </div>
              </div>
              <SizedBox :height="10" />
              <input
                type="file"
                class="form-control"
                placeholder="Foto diri Yatim / Dhuafa"
                @change="onFotoYatimDhuafaChange"
                accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, .svg"
              />
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="kk_url"
                ><strong>Surat SKTM</strong> ( Surat Keterangan Tidak
                Mampu )</label
              >
              <div class="card">
                <div class="cekrek" v-if="!sktm_url">
                  <img src="/img/cekrek.png" />
                </div>
                <div id="preview" class="preview">
                  <img v-if="sktm_url" :src="sktm_url" />
                </div>
              </div>
              <SizedBox :height="10" />
              <input
                type="file"
                class="form-control"
                placeholder="Foto/Scan SKTM Anda"
                @change="onSKTMChange"
                accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, .svg"
              />
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="kk_url"
                ><strong>Surat SKTM Masjed</strong> ( Dari Masjed yang
                didaftarkan )</label
              >
              <div class="card">
                <div class="cekrek" v-if="!sktmmasjed_url">
                  <img src="/img/cekrek.png" />
                </div>
                <div id="preview" class="preview">
                  <img v-if="sktmmasjed_url" :src="sktmmasjed_url" />
                </div>
              </div>
              <SizedBox :height="10" />
              <input
                type="file"
                class="form-control"
                placeholder="Foto/Scan SKTM dari Masjed"
                @change="onSKTMMASJEDChange"
                accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, .svg"
              />
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="nik"><strong>Foto KTP</strong></label>
              <div class="card">
                <div class="cekrek" v-if="!nik_url">
                  <img src="/img/cekrek.png" />
                </div>
                <div id="preview" class="preview">
                  <img v-if="nik_url" :src="nik_url" />
                </div>
              </div>
              <SizedBox :height="10" />
              <input
                type="file"
                class="form-control"
                placeholder="NIK Anda"
                @change="onKTPChange"
                accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, .svg"
              />
            </div>
            <div class="form-group">
              <label for="nik"
                ><strong>NIK ( Nomor Induk KTP )</strong></label
              >
              <input
                v-model="nik"
                type="text"
                class="form-control"
                placeholder="NIK Anda"
                name="nik"
                v-number-only
              />

              <div
                class="error"
                v-if="$v.nik.$dirty && !$v.nik.required"
              >
                NIK wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="kk_url"><strong>Foto KK</strong></label>
              <div class="card">
                <div class="cekrek" v-if="!kk_url">
                  <img src="/img/cekrek.png" />
                </div>
                <div id="preview" class="preview">
                  <img v-if="kk_url" :src="kk_url" />
                </div>
              </div>
              <SizedBox :height="10" />
              <input
                type="file"
                class="form-control"
                placeholder="KK Anda"
                @change="onKKChange"
                accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, .svg"
              />
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="nik"
                ><strong>No KK ( Kartu Keluarga )</strong></label
              >
              <input
                v-model="kk"
                type="text"
                class="form-control"
                placeholder="Nomor KK Anda"
                name="kk"
                v-number-only
              />

              <div
                class="error"
                v-if="$v.kk.$dirty && !$v.kk.required"
              >
                No KK wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="nik"
                ><strong>Nama Kepala Keluarga</strong></label
              >
              <input
                v-model="kepala_keluarga"
                type="text"
                class="form-control"
                placeholder="Nama Kepala Keluarga Anda"
                name="kepala_keluarga"
              />
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="provinsi"><strong>Provinsi</strong></label>
              <Select2
                v-model="provinsi"
                :options="dataProvinsi"
                @change="changeKota($event)"
                :settings="{ placeholder: 'Pilih Provinsi' }"
              />
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="kota"><strong>Kota</strong></label>
              <Select2
                v-model="kota"
                :options="dataKota"
                @change="changeKecamatan($event)"
                :settings="{ placeholder: 'Pilih Kota' }"
              />
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="kecamatan"
                ><strong>Kecamatan</strong></label
              >
              <Select2
                v-model="kecamatan"
                :options="dataKecamatan"
                :settings="{ placeholder: 'Pilih Kecamatan' }"
              />
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="masjed_address">
                <strong>Alamat Tinggal </strong>
                <button
                  type="button"
                  class="btn btn-titik-jemput"
                  @click="modalMap()"
                >
                  Cari Alamat
                </button>
              </label>
              <textarea
                name="alamat"
                v-model="alamat"
                class="form-control"
                placeholder="Alamat Anda"
                style="min-height: 150px"
              ></textarea>
            </div>

            <SizedBox :height="35" />

            <div style="display:flex; gap: 5px;">
              <button
                type="button"
                class="btn button-kembali"
                @click="backToGate"
              >
                Kembali
              </button>
              <button
                type="submit"
                class="btn button-daftarkan"
                :disabled="isSubmit"
              >
                {{ isSubmit ? 'Memproses Data...' : 'Daftar' }}
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Modal Map -->
      <modal
        class="map-wrapper"
        name="map-wrapper"
        :clickToClose="false"
      >
        <div class="map-body">
          <div class="map-search">
            <div class="search-wrapper">
              <GmapAutocomplete
                @place_changed="setPlace"
                class="form-control"
                :options="{ fields: ['geometry'] }"
              />
              <img src="/img/icon-search.png" class="icon-search" />
            </div>
          </div>
          <gmap-map
            :center="center"
            :zoom="zoom"
            style="width: 100%; height: 100% !important;"
            :options="mapOptions"
          >
            <gmap-marker
              :position="center"
              @click="center = center"
              :draggable="true"
              @drag="updateCoordinates"
              :icon="{
                url:
                  'https://api.masjed.id/assets/icons/menus/marker_cari_masjed.png',
                scaledSize: { width: 70, height: 70 },
                labelOrigin: { x: 16, y: -10 },
              }"
            ></gmap-marker>
          </gmap-map>
          <div class="current-location" @click="geolocate">
            <font-awesome-icon icon="crosshairs" />
          </div>
        </div>
        <SizedBox :height="15" />
        <div class="map-footer">
          <a
            href="javascript:void(0)"
            class="btn button-daftarkan"
            @click="saveCoordinates"
            >Simpan</a
          >
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import TopBar from '@/components/FixedTopbar.vue';
import SizedBox from '@/components/SizedBox.vue';
import { required, email } from 'vuelidate/lib/validators';
import axios from '@/utils/masjedapi';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';
import Compressor from 'compressorjs';

export default {
  name: 'donation-detail',
  components: {
    TopBar,
    SizedBox,
    DatePicker,
    Select2,
  },
  data() {
    return {
      isSubmit: false,

      masjidid: '',
      person_type: '',

      fullname: '',
      email: '',
      no_telp: '',
      tanggallahir: '',
      jeniskelamin: '',
      agama: '',
      provinsi: '',
      kota: '',
      kecamatan: '',
      alamat: '',
      tempat_lahir: '',
      kepala_keluarga: '',

      pendidikan_terakhir: '',
      kejuruan: '',
      gelar_akademis: '',

      faham: '',
      kepakaran: '',
      pekerjaan: '',
      organisasi: '',
      alamat_kerja: '',
      majelis: '',
      lembaga_pribadi: [],
      kewarganegaraan: '',
      status_pernikahan: '',

      materi_andalan: '',

      nik: '',
      nik_url: null,
      nik_file: null,

      kk: '',
      kk_url: null,
      kk_file: null,

      fotoyatimdhuafa: '',
      fotoyatimdhuafa_url: null,
      fotoyatimdhuafa_file: null,

      sktm: '',
      sktm_url: null,
      sktm_file: null,

      sktmmasjed: '',
      sktmmasjed_url: null,
      sktmmasjed_file: null,

      dataPersonType: [
        { id: 'YATIM', text: 'Yatim' },
        { id: 'DHUAFA', text: 'Dhuafa' },
      ],
      dataJenisKelamin: [
        { id: 'L', text: 'Laki-laki' },
        { id: 'P', text: 'Perempuan' },
      ],
      dataMasjid: [
        { id: 'MASJED', text: 'Yayasan Masjed Indonesia Digital' },
        { id: 'YDYM', text: 'Yayasan Dompet Yatim & Mesjid' },
      ],
      dataPendidikan: [],
      dataAgama: [],
      dataProvinsi: [],
      dataKota: [],
      dataKecamatan: [],

      // Maps
      center: { lat: 45.508, lng: -73.587 },
      zoom: 17,
      markers: [],
      currentPlace: null,
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true,
      },

      reff_code: '',
    };
  },
  validations: {
    fullname: {
      required,
    },
    masjidid: {
      required,
    },
    email: {
      required,
      email,
    },
    no_telp: {
      required,
    },
    nik: {
      required,
    },
    person_type: {
      required,
    },
    kk: {
      required,
    },
    tanggallahir: {
      required,
    },
    jeniskelamin: {
      required,
    },
  },
  mounted() {
    window.scrollTo(0, 0);

    this.reff_code = this.$route.params.ref_code;

    this.loadMasjid();
    this.loadProvinsi();
    this.loadPendidikan();
    this.geolocate();
  },
  methods: {
    escapeMarkup(markup) {
      return markup;
    },
    templateResult(data) {
      return data.text;
    },
    templateSelection(data) {
      return data.text;
    },
    async loadMasjid() {
      const options = await axios.get(`/akusisi/load-masjid`);
      const { data } = options.data;

      data.map((item) => {
        this.dataMasjid.push({
          id: item.id,
          text: item.name,
        });
      });
    },
    async loadPendidikan() {
      const options = await axios.get(`/akusisi/load-pendidikan`);
      const { data } = options.data;

      data.map((item) => {
        this.dataPendidikan.push({
          id: item.id,
          text: item.name,
        });
      });
    },
    backToGate() {
      this.$router.push({
        name: 'akusisi-user-yatimdhuafa-list',
        params: { ref_code: this.reff_code },
      });
    },
    async handleRegister() {
      this.$v.$touch();

      this.isSubmit = true;

      const formData = new FormData();
      if (this.nik_file) formData.append('foto_ktp', this.nik_file);
      if (this.kk_file) formData.append('foto_kk', this.kk_file);
      if (this.fotoyatimdhuafa_file)
        formData.append(
          'foto_yatimdhuafa',
          this.fotoyatimdhuafa_file
        );
      if (this.sktm_file)
        formData.append('foto_sktm', this.sktm_file);
      if (this.sktmmasjed_file)
        formData.append('foto_sktm_masjed', this.sktmmasjed_file);

      var target = this.no_telp;
      var nope =
        target.indexOf('0') == 0
          ? `62${target.substring(1)}`
          : target;

      formData.append('nama', this.fullname);
      formData.append('email', this.email);
      formData.append('nohp', nope);
      formData.append('nik', this.nik);
      formData.append('kk', this.nik);
      formData.append('gender', this.jeniskelamin);
      formData.append('tanggal_lahir', this.tanggallahir);
      formData.append('tempat_lahir', this.tempat_lahir);

      formData.append('person_type', this.person_type);
      formData.append('masjid_id', this.masjidid);

      formData.append('pendidikan', this.pendidikan_terakhir);
      formData.append('agama', this.agama);
      formData.append('alamat', this.alamat);
      formData.append('provinsi', this.provinsi);
      formData.append('kabupaten', this.kota);
      formData.append('kecamatan', this.kecamatan);
      formData.append('latitude', this.center.lat);
      formData.append('longitude', this.center.lng);
      formData.append('reff_code', this.reff_code);

      if (this.kepala_keluarga)
        formData.append('kepala_keluarga', this.kepala_keluarga);

      if (this.$v.$invalid) {
        this.isSubmit = false;
        this.$toasted.show(
          'Ada kesalahan pengisian form, periksa kembali.',
          {
            type: 'error',
            position: 'top-center',
            duration: 3000,
          }
        );
      } else {
        const self = this;
        axios
          .post(`/akusisi/yatimdhuafa`, formData)
          .then((response) => {
            const { data } = response;
            self.$toasted.show(data.message, {
              type: 'success',
              position: 'bottom-center',
              duration: 3000,
              class: 'toasting',
            });
            setTimeout(() => {
              this.$router.push({
                name: 'akusisi-user-yatimdhuafa-success',
                params: { ref_code: this.reff_code },
              });
            }, 2000);
          })
          .catch((error) => {
            const { data } = error.response;
            self.$toasted.show(data.message, {
              type: 'error',
              position: 'bottom-center',
              duration: 3000,
              class: 'toasting',
            });
          });
      }
      this.isSubmit = false;
    },
    onKTPChange(e) {
      const file = e.target.files[0];

      if (!file) {
        return;
      }

      this.nik_url = URL.createObjectURL(file);
      // this.nik_file = file;

      const self = this;

      new Compressor(file, {
        quality: 0.6,
        width: 600,
        success(result) {
          self.nik_file = new File([result], file.name, {
            type: file.type,
            lastModified: new Date().getTime(),
          });
        },
        error(err) {
          console.log('error', err.message);
          return null;
        },
      });
    },
    onKKChange(e) {
      const file = e.target.files[0];

      if (!file) {
        return;
      }

      this.kk_url = URL.createObjectURL(file);
      // this.nik_file = file;

      const self = this;

      new Compressor(file, {
        quality: 0.6,
        width: 600,
        success(result) {
          self.kk_file = new File([result], file.name, {
            type: file.type,
            lastModified: new Date().getTime(),
          });
        },
        error(err) {
          console.log('error', err.message);
          return null;
        },
      });
    },
    onFotoYatimDhuafaChange(e) {
      const file = e.target.files[0];

      if (!file) {
        return;
      }

      this.fotoyatimdhuafa_url = URL.createObjectURL(file);
      // this.fotoyatimdhuafa_file = file;

      const self = this;

      new Compressor(file, {
        quality: 0.6,
        width: 600,
        success(result) {
          self.fotoyatimdhuafa_file = new File([result], file.name, {
            type: file.type,
            lastModified: new Date().getTime(),
          });
        },
        error(err) {
          console.log('error', err.message);
          return null;
        },
      });
    },
    onSKTMChange(e) {
      const file = e.target.files[0];

      if (!file) {
        return;
      }

      this.sktm_url = URL.createObjectURL(file);
      // this.sktm_file = file;

      const self = this;

      new Compressor(file, {
        quality: 0.6,
        width: 600,
        success(result) {
          self.sktm_file = new File([result], file.name, {
            type: file.type,
            lastModified: new Date().getTime(),
          });
        },
        error(err) {
          console.log('error', err.message);
          return null;
        },
      });
    },
    onSKTMMASJEDChange(e) {
      const file = e.target.files[0];

      if (!file) {
        return;
      }

      this.sktmmasjed_url = URL.createObjectURL(file);
      // this.sktmmasjed_file = file;

      const self = this;

      new Compressor(file, {
        quality: 0.6,
        width: 600,
        success(result) {
          self.sktmmasjed_file = new File([result], file.name, {
            type: file.type,
            lastModified: new Date().getTime(),
          });
        },
        error(err) {
          console.log('error', err.message);
          return null;
        },
      });
    },
    async loadProvinsi() {
      const options = await axios.get(`/helper/common/province`);
      const { data } = options.data;

      data.map((item) => {
        this.dataProvinsi.push({
          id: item.code,
          text: item.name,
        });
      });
    },
    async loadKota(provId) {
      const options = await axios.get(
        `/helper/common/kota?province_id=${provId}`
      );
      const { data } = options.data;

      let temp = [];
      data.map((item) => {
        temp.push({
          id: item.code,
          text: item.name,
        });
      });
      this.dataKota = temp;
    },
    async loadKecamatan(kotaId) {
      const options = await axios.get(
        `/helper/common/kecamatan?kota_id=${kotaId}`
      );
      const { data } = options.data;

      let temp = [];
      data.map((item) => {
        temp.push({
          id: item.code,
          text: item.name,
        });
      });
      this.dataKecamatan = temp;
    },
    changeKota(val) {
      this.kota = '';
      this.loadKota(val);
    },
    changeKecamatan(val) {
      this.kecamatan = '';
      this.loadKecamatan(val);
    },
    modalMap() {
      this.$modal.show('map-wrapper');
    },
    setPlace(place) {
      const lat = parseFloat(
        place.geometry.location.lat().toFixed(7)
      );
      const lng = parseFloat(
        place.geometry.location.lng().toFixed(7)
      );

      this.center = {
        lat: lat,
        lng: lng,
      };
    },
    geolocate() {
      const self = this;

      navigator.geolocation.getCurrentPosition((position) => {
        const lat = parseFloat(position.coords.latitude);
        const lng = parseFloat(position.coords.longitude);

        this.center = {
          lat: lat,
          lng: lng,
        };

        axios
          .post(`/findmasjed/sekitar`, {
            lat: lat,
            lng: lng,
          })
          .then((response) => {
            const { data } = response.data;

            self.markers = [];
            data.map((element) => {
              const marker = {
                lat: element.lat,
                lng: element.lng,
                is_claim: element.is_claim,
                masjidmaps_id: element.masjidmaps_id,
                nama_masjid: element.nama_masjid,
              };

              self.markers.push(marker);
            });
          });

        this.masjidmaps_id = '';
        this.masjid_name = '';
      });
    },
    updateCoordinates(location) {
      const lat = parseFloat(location.latLng.lat().toFixed(7));
      const lng = parseFloat(location.latLng.lng().toFixed(7));

      this.center = {
        lat: lat,
        lng: lng,
      };

      this.$toasted.show('Titik berhasil diupdate.', {
        type: 'success',
        position: 'bottom-center',
        duration: 3000,
      });
    },
    updateCoordinates(location) {
      const lat = parseFloat(location.latLng.lat().toFixed(7));
      const lng = parseFloat(location.latLng.lng().toFixed(7));

      this.center = {
        lat: lat,
        lng: lng,
      };
    },
    handleClick(lat, lng, mapid = '', name = '') {
      this.center = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      };

      this.masjidmaps_id = mapid;
      this.masjid_name = name;

      this.$toasted.show('Titik berhasil diupdate.', {
        type: 'success',
        position: 'bottom-center',
        duration: 3000,
      });
    },
    saveCoordinates() {
      this.$modal.hide('map-wrapper');
      this.$toasted.show('Titik berhasil diset.', {
        type: 'success',
        position: 'bottom-center',
        duration: 3000,
      });
      this.getAddresss(
        parseFloat(this.center.lat),
        parseFloat(this.center.lng)
      );
    },
    getAddresss(lat, lng) {
      var url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyDd-Xv_wBoM5_oaEwAuDpIy_nTRCkKX2EI&sensor=false`;
      var self = this;
      $.get(url, function(data) {
        var results = data.results;
        if (data.status === 'OK') {
          if (results[0]) {
            var address_components = results[0];
            self.alamat = address_components.formatted_address;
          }
        }
      });
    },
  },
  directives: {
    numberOnly: {
      bind: function(el) {
        el.handler = function() {
          el.value = el.value.replace(/\D+/, '');
        };
        el.addEventListener('input', el.handler);
      },
      unbind: function(el) {
        el.removeEventListener('input', el.handler);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0px auto;
  box-sizing: border-box;
  top: 0px;
  padding: 0px;
  min-height: calc(100vh - 0px);
}

.wrapper-form {
  position: relative;

  h3 {
    position: absolute;
    font-size: 17px;
    margin: 0px;
    left: -15px;
    background: transparent
      linear-gradient(180deg, #20d2a6 0%, #189e7d 100%) 0% 0%
      no-repeat padding-box;
    padding: 5px 40px 5px 10px;
    color: #fff;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}

.error {
  font-size: 11px;
  color: rgb(255, 13, 13);
}

.lembaga_pribadi {
  list-style-type: none;
  margin: 0px;
  padding: 0px;
}

.button-daftarkan {
  display: block;
  margin: 0 auto;
  font-size: 13px;
  background: #20d2a6 !important;
  color: #fff !important;
  width: 100% !important;
  border-radius: 5px !important;

  &:hover {
    background: #189e7d !important;
  }
}

.button-kembali {
  display: block;
  margin: 0 auto;
  font-size: 13px;
  border-radius: 5px !important;
  background: #e62020 !important;
  color: #fff !important;
  width: 100% !important;

  &:hover {
    background: #991515 !important;
  }
}
</style>
